export enum TicketRequestAction {
  Reply = 'reply',
  Approve = 'approve',
  Cancel = 'cancel',
  Archive = 'archive',
  Resolve = 'resolve'
}
